import { PureComponent } from 'react'
import { Field as FinalFormField } from 'react-final-form'

import { isDeepEqual } from '@/server-data'

import TimeWindowListField from './TimeWindowListField'
import { PublicProps as Props, FieldRenderProps } from './typings'

export default class TimeWindowListFieldWrapper extends PureComponent<Props> {
  render() {
    const { name, ...props } = this.props

    return (
      <FinalFormField
        {...props}
        name={name}
        isEqual={isDeepEqual}
        render={(formProps: FieldRenderProps) => {
          return <TimeWindowListField {...this.props} formProps={formProps} />
        }}
      />
    )
  }
}
